import { render, staticRenderFns } from "./Repacking.vue?vue&type=template&id=453c0c73"
import script from "./Repacking.vue?vue&type=script&lang=js"
export * from "./Repacking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports